import type { Cart } from '@/types/booking';

/** Returns the service ids of the last cart item, or `[]` without one. */
export function getCartServiceIds(cart: Cart | null | undefined): string[] {
  return cart?.items.at(-1)?.services.map(({ id }) => id) ?? [];
}
